import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchSupplies } from '../../../actions/supplies';
import { getCurrencySymbol } from '../../../helpers';
import { SUPPLIES_COUNT_ON_PAGE } from '../../../config';
import DesktopLayout from './DesktopLayout';
import MobileLayout from './MobileLayout';
import Adaptive from '../../common/Adaptive';
import { useDebounce } from '../../../helpers/useDebounce';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

import moment from 'moment';
import numeral from 'numeral';
import 'numeral/locales/ru';
import 'moment/locale/zh-cn';
import 'moment/locale/ru';
moment.locale('zh-cn');
moment.locale('ru');
numeral.locale('ru');

const SuppliesPage = (props) => {
  const dispatch = useDispatch();

  const { t, i18n } = useAutoTranslation();
  const localeCode = i18n.language === 'cn' ? 'zh-cn' : 'ru';

  const getSupplies = useSelector((state) => state.supplies.getSupplies);
  const supplies = useSelector((state) => state.supplies.supplies);

  const suppliesCount = useSelector((state) => state.supplies.suppliesCount);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');

  const { checkoutSettings } = useSelector((state) => state.settings);
  const currencySymbol = getCurrencySymbol(checkoutSettings.currency);

  const [filters, setFilters] = useState({});

  const fetchSupplieList = (page = 0) => {
    setPage(page);
    return dispatch(
      fetchSupplies({
        page,
        size: SUPPLIES_COUNT_ON_PAGE,
        id: search,
        ...filters,
      }),
    );
  };

  const debouncedFetchSupplieList = useDebounce(fetchSupplieList, 500);

  useEffect(() => {
    debouncedFetchSupplieList();
  }, [search, filters]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(0);
  };

  const getSupplieDateString = (date) => {
    const currentMoment = moment(date);
    let format = 'DD MMM';
    if (moment().diff(currentMoment, 'months') > 6) {
      format += ' YYYY';
    }
    format += ', HH:mm';
    return moment(date).locale(localeCode).format(format);
  };

  const handleSetFilters = (filters) => {
    setFilters(filters);
  };

  const adaptiveProps = {
    search,
    handleSearch,
    getSupplies,
    supplies,
    getSupplieDateString,
    suppliesCount,
    page,
    fetchSupplieList,
    currencySymbol,
    handleSetFilters,
  };

  return (
    <Adaptive
      DekstopComponent={DesktopLayout}
      MobileComponent={MobileLayout}
      adaptiveProps={adaptiveProps}
    />
  );
};

export default SuppliesPage;
